import React from 'react';
import { Box } from '@material-ui/core';
import { Credentials } from '@app/shared/types';
import { CredentialsInputGroup } from './CredentialsInputGroup';

interface CredentialsListProps {
  dxmCredentials?: Credentials;
  externalCredentials?: Credentials[];
  newCredentials: Credentials[];
  deletedCredentials: Set<string>;
  shouldValidate?: boolean;
  onDeleteNew: (index: number) => void;
  onDeleteExisting: (clientId: string) => void;
  onUpdateNew: (index: number, data: Credentials) => void;
  onUpdateExisting: (clientId: string, data: Credentials) => void;
  hasWritePermission?: boolean;
  usedByProject: Record<string, Set<string>>;
}

export const CredentialsList: React.FC<CredentialsListProps> = ({
  dxmCredentials,
  externalCredentials = [],
  newCredentials,
  deletedCredentials,
  shouldValidate = false,
  onDeleteNew,
  onDeleteExisting,
  onUpdateNew,
  onUpdateExisting,
  hasWritePermission,
  usedByProject,
}) => {
  return (
    <Box display="flex" flexDirection="column" style={{ gap: 24 }}>
      {dxmCredentials && (
        <CredentialsInputGroup
          data={dxmCredentials}
          title="DXM Client Credentials"
          disabled
        />
      )}

      {externalCredentials
        .filter(cred => !deletedCredentials.has(cred.clientId))
        .map(credentials => (
          <CredentialsInputGroup
            key={credentials.name}
            data={credentials}
            title={credentials.name}
            hasEdit={hasWritePermission}
            hasDelete={hasWritePermission}
            shouldValidate={shouldValidate}
            onDelete={() => onDeleteExisting(credentials.clientId)}
            onChange={data => onUpdateExisting(credentials.clientId, data)}
          />
        ))}

      {newCredentials.map((credentials, index) => (
        <CredentialsInputGroup
          key={`new-${index}`}
          data={credentials}
          title={credentials.name || 'New Client Credentials'}
          isNew
          hasDelete
          shouldValidate={shouldValidate}
          onDelete={() => onDeleteNew(index)}
          onChange={data => onUpdateNew(index, data)}
          usedByProject={usedByProject}
        />
      ))}
    </Box>
  );
};
